import { render } from "./target_history.vue?vue&type=template&id=05f521cf"
import script from "./target_history.vue?vue&type=script&lang=js"
export * from "./target_history.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__